export const activityTableColumns = [
  { title: 'Date', key: 'DATE', width: 14, keySort: 'trade date' },
  { title: 'Commitment', key: 'STRATEGY', width: 15, keySort: 'commitment' },
  { title: 'Transaction Type', key: 'TRANSACTION_TYPE', width: 15, keySort: 'transaction type' },
  { title: 'Amount', key: 'AMOUNT', width: 14, keySort: 'amount' },
  { title: 'Distribution To Date', key: 'DISTRIBUTIONS_TO_DATE', width: 14, keySort: 'distribution to date' },
  { title: 'Remaining Capital', key: 'REMAINING_CAPITAL', width: 14, keySort: 'remaining capital' },
  { title: 'Market Value', key: 'MARKET_VALUE', width: 14, keySort: 'market value' }
];

export const activityMobileTableSort = [
  {
    title: 'Date • Newest -> Oldest',
    key: 'DATE',
    asc: false
  },
  {
    title: 'Date • Oldest -> Newest',
    key: 'DATE',
    asc: true
  },
  {
    title: 'Commitment • A -> Z',
    key: 'STRATEGY',
    asc: true
  },
  {
    title: 'Commitment • Z -> A',
    key: 'STRATEGY',
    asc: false
  },
  {
    title: 'Transaction Type • A -> Z',
    key: 'TRANSACTION_TYPE',
    asc: true
  },
  {
    title: 'Transaction Type • Z -> A',
    key: 'TRANSACTION_TYPE',
    asc: false
  },
  {
    title: 'Amount • Max -> Min',
    key: 'AMOUNT',
    asc: false
  },
  {
    title: 'Amount • Min -> Max',
    key: 'AMOUNT',
    asc: true
  },
  {
    title: 'Distribution To Date • Max -> Min',
    key: 'DISTRIBUTIONS_TO_DATE',
    asc: false
  },
  {
    title: 'Distribution To Date • Min -> Max',
    key: 'DISTRIBUTIONS_TO_DATE',
    asc: true
  },
  {
    title: 'Remaining Capital • Max -> Min',
    key: 'REMAINING_CAPITAL',
    asc: false
  },
  {
    title: 'Remaining Capital • Min -> Max',
    key: 'REMAINING_CAPITAL',
    asc: true
  },
  {
    title: 'Market Value • Max -> Min',
    key: 'MARKET_VALUE',
    asc: false
  },
  {
    title: 'Market Value • Min -> Max',
    key: 'MARKET_VALUE',
    asc: true
  }
];

export const activityTabFilterBarItems = [
  {
    type: 'filter',
    name: 'Contributions',
    value: 'CONTRIBUTIONS',
    enabled: false,
    count: 0
  },
  {
    type: 'filter',
    name: 'Distributions',
    value: 'DISTRIBUTIONS',
    enabled: false,
    count: 0
  },
  {
    type: 'filter',
    name: 'Recallable Distributions',
    value: 'RECALLABLE_DISTRIBUTIONS',
    enabled: false,
    count: 0
  },
  {
    type: 'filter',
    name: 'Valuations',
    value: 'VALUATIONS',
    enabled: false,
    count: 0
  }
];
